<div class="mt-8 flex">
  <div class="font-bold text-xl">{{'handover.equipment' |translate}}</div>
</div>
<div *ngIf="hasEquipment else noDataTemp" class="mt-1 flex flex-wrap tk-border-gray-2 rounded-xl px-5 py-4">
  <mat-checkbox *ngFor="let item of model?.equipmentItems" disabled [checked]="true" class="mr-5">
    <span class="text-black">{{item}}</span>
  </mat-checkbox>
</div>

<ng-template #noDataTemp>
  <div class="tk-border-gray-2 px-5 py-4 rounded-xl">
    {{'handover.no-equipment' | translate}}
  </div>
</ng-template>
